import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../../config';
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import './Login.css'

const Login = () => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [alerts, setalerts] = useState(false)
    const [Loader, setLoader] = useState(false)
    const navigate = useNavigate();
    const [passwordShown, setPasswordShown] = useState(false);
    const [forgotPasswordModal, setForgotPasswordModal] = useState(false);
    const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
    const [forgotPasswordLoader, setForgotPasswordLoader] = useState(false);
    const [forgotPasswordMessage, setForgotPasswordMessage] = useState('');

    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
    };

    const toggleForgotPasswordModal = () => {
        setForgotPasswordModal(!forgotPasswordModal);
        setForgotPasswordEmail('');
        setForgotPasswordMessage('');
    };

    const handleForgotPassword = async () => {
        if (!forgotPasswordEmail) {
            setForgotPasswordMessage('Please enter your email address');
            return;
        }

        setForgotPasswordLoader(true);
        try {
            const response = await fetch(API_URL + '/distributor/v2/forgot-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: forgotPasswordEmail,
                }),
            });

            const data = await response.json();

            if (data.success || response.status === 404) {
                setForgotPasswordMessage('If this email exists in our system, you will receive a password reset link shortly.');
                setTimeout(() => {
                    toggleForgotPasswordModal();
                }, 2000);
            } else {
                setForgotPasswordMessage(data.message || 'An error occurred. Please try again.');
            }
        } catch (error) {
            setForgotPasswordMessage('If this email exists in our system, you will receive a password reset link shortly.');
        } finally {
            setForgotPasswordLoader(false);
        }
    };

    async function loginUser(event) {
        event.preventDefault()
        setalerts(false)
        setLoader(true)

        const response = await fetch(API_URL + '/distributor/new/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email,
                password,
            }),
        })

        const data = await response.json()
        setLoader(false)

        if (data.success) {
            const userType = data.data[0].user_type;
            localStorage.setItem('user_id', data.user_id);
            localStorage.setItem('accessToken', data.accessToken);
            localStorage.setItem('user_type', userType);
            localStorage.setItem('uid', data.data[0].uid);
            localStorage.setItem('user_name', data.data[0].firstname + " " + data.data[0].lastname);
            navigate("/distributor-dashboard");
        } else {
            setalerts(true)
        }
    }

    return (
        <div className="login-container">
            <div className="login-wrapper-outer">
                <div className="login-wrapper">
                {/* Left Side - Branding */}
                <div className="login-branding">
                    <div className="branding-content">
                        <h1>BetterPhysiolgy</h1>
                        <p>Distributors' Dashboard</p>
                        <div className="branding-features">
                            <div className="feature">
                                <i className="fas fa-chart-line"></i>
                                <span>Real-time Analytics</span>
                            </div>
                            <div className="feature">
                                <i className="fas fa-shield-alt"></i>
                                <span>Secure Access</span>
                            </div>
                            <div className="feature">
                                <i className="fas fa-users"></i>
                                <span>Easy Management</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Side - Login Form */}
                <div className="login-form-section">
                    <form onSubmit={loginUser} className="login-form">
                        <div className="form-header">
                            <h2>Welcome Back</h2>
                            <p>Sign in to your account</p>
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">Email Address</label>
                            <input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                                className="form-input"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <div className="password-input-wrapper">
                                <input
                                    id="password"
                                    type={passwordShown ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Enter your password"
                                    className="form-input"
                                    required
                                />
                                <i
                                    className={passwordShown ? "fa fa-eye-slash" : "fa fa-eye"}
                                    onClick={togglePasswordVisiblity}
                                    style={{ cursor: 'pointer' }}
                                ></i>
                            </div>
                        </div>

                        {alerts && (
                            <div className="alert-error">
                                <i className="fa fa-exclamation-circle"></i>
                                <span>Invalid email or password</span>
                            </div>
                        )}

                        <button
                            className="login-button"
                            type="submit"
                            disabled={Loader}
                        >
                            {Loader ? (
                                <div className="button-loader"></div>
                            ) : (
                                <>
                                    <span>Sign In</span>
                                    <i className="fas fa-arrow-right"></i>
                                </>
                            )}
                        </button>

                        {/* <div className="form-footer">
                            <button
                                type="button"
                                onClick={toggleForgotPasswordModal}
                                className="forgot-password-btn"
                            >
                                Forgot your password?
                            </button>
                        </div> */}
                    </form>
                </div>
            </div>

            {/* Forgot Password Modal */}
            <Modal
                isOpen={forgotPasswordModal}
                toggle={toggleForgotPasswordModal}
                centered
                className="forgot-password-modal"
            >
                <ModalHeader toggle={toggleForgotPasswordModal} className="modal-header">
                    <i className="fas fa-lock"></i> Reset Password
                </ModalHeader>
                <ModalBody className="modal-body">
                    {forgotPasswordMessage ? (
                        <div className="modal-success">
                            <i className="fas fa-check-circle"></i>
                            <p>{forgotPasswordMessage}</p>
                        </div>
                    ) : (
                        <div className="modal-form">
                            <p className="modal-description">
                                Enter your email address and we'll send you a link to reset your password.
                            </p>
                            <div className="form-group">
                                <label htmlFor="forgotEmail">Email Address</label>
                                <input
                                    id="forgotEmail"
                                    type="email"
                                    placeholder="Enter your email"
                                    value={forgotPasswordEmail}
                                    onChange={(e) => setForgotPasswordEmail(e.target.value)}
                                    className="form-input"
                                    required
                                />
                            </div>
                        </div>
                    )}
                </ModalBody>
                {!forgotPasswordMessage && (
                    <ModalFooter className="modal-footer">
                        <button
                            onClick={toggleForgotPasswordModal}
                            className="btn-cancel"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleForgotPassword}
                            disabled={forgotPasswordLoader}
                            className="btn-primary"
                        >
                            {forgotPasswordLoader ? 'Sending...' : 'Send Reset Link'}
                        </button>
                    </ModalFooter>
                )}
            </Modal>
            </div>
            <footer className="login-footer">
                <p>&copy; {new Date().getFullYear()} BetterPhysiology. All rights reserved.</p>
            </footer>
        </div>
    );
}

export default Login;